<!-- Быстрое действие «Сдать/Принять ТС» с выбором ТС и запуском мастера. -->
<template>
  <HomeQuickActionCard
    label="Сдать/Принять ТС"
    description="Последовательно сфотографировать ТС и подписать акт"
    icon-name="clipboardCheck"
    color="green"
    :list-to="{ name: 'VehicleInspections' }"
    list-label="Открыть акты приемки-передачи"
    list-subject="акты"
    @click="openSelection"
  />

  <VehicleInspectionLauncher ref="launcher" @completed="handleCompleted" />
</template>

<script>
import HomeQuickActionCard from "@/components/Home/QuickActionCard.vue";
import VehicleInspectionLauncher from "@/components/Vehicle/Inspection/Launcher.vue";

export default {
  name: "HomeVehicleInspectionAction",
  components: { HomeQuickActionCard, VehicleInspectionLauncher },
  methods: {
    openSelection() {
      this.$refs.launcher.openSelection();
    },
    async handleCompleted({ vehicle }) {
      const vehicleId = vehicle?.id;
      if (vehicleId == null) return;

      await this.$router.push({ name: "VehicleDetails", params: { id: vehicleId }, query: { tab: "inspections" } });
    },
  },
};
</script>
